<template>
  <div v-if="dataSource.length > 0">
    <label>{{ $t('history') }}</label>
    <HKLTable
      class="green-fitout__sub-folders-histories"
      :columns="columns"
      :dataSource="dataSource"
      :onSort="false"
    />
  </div>
</template>
<script>
import lodash from 'lodash'
import { computed, unref } from 'vue-demi'
import HKLTable from '@/controls/Table/HKLTable'
import i18n from '@/utils/i18n'
import dateUtil from '@/utils/dateUtil'
import { useStoreGetters } from '../../../store'
import { GREEN_FITOUT_FOLDER_ACTIONS } from './consts'
import { useGreenFitoutPerms } from './hook'

/**
 * @type {import('vue').ComponentOptions}
 */
export default {
  components: {
    HKLTable,
  },
  props: {
    subFolder: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    const { isTenant } = useStoreGetters('user', ['isTenant'])
    const { canViewPoint } = useGreenFitoutPerms()
    const columns = computed(() => {
      const list = [{
        dataIndex: 'createdAt',
        title: i18n.t('table.header.date'),
        render: (item) => dateUtil.format(item, 'DD MMM YY HH:mm'),
      }, {
        dataIndex: 'action',
        title: i18n.t('table.header.action'),
        render: (item) => i18n.t(`tenantProjects.greenFitOut.history.action.${item}`),
      }, {
        dataIndex: 'createdBy',
        title: i18n.t('table.header.actionBy'),
        render: (item) => item && item.displayName,
      }, {
        dataIndex: 'point',
        title: i18n.t('table.header.points'),
        render: (value) => typeof value === 'number' ? `${value}` : '',
      }, {
        dataIndex: 'comment',
        title: i18n.t('table.header.comment'),
      }]
      if (!unref(isTenant) && unref(canViewPoint)) return list
      return list.filter(item => item.dataIndex !== 'point')
    })
    const dataSource = computed(() => {
      const histories = lodash.orderBy(props.subFolder.histories || [], 'createdAt', 'desc')
      if (!unref(isTenant) && unref(canViewPoint)) return histories
      return histories.filter(item => item.action !== GREEN_FITOUT_FOLDER_ACTIONS.UPDATE_POINTS)
    })
    return {
      columns,
      dataSource,
    }
  },
}
</script>
<style lang="scss" scoped>
.green-fitout__sub-folders-histories ::v-deep {
  margin-left: 0;
  margin-right: 0;
  .comment {
    word-break: break-word;
  }
}
</style>
